import { apiDataIdIndex, apiFormFindByCode, apiFormFindById, DataItemProps, FormItemProps } from "apis";
import { FC, Fragment, useEffect, useState, createContext, useContext, ReactNode } from "react";
import { Outlet, useParams } from "react-router-dom";
import AppLoading from "components/AppLoading";
import { apiFieldIndex, FieldItemProps } from "apis/field";
import { PaginationProps } from "utils/types/API";
import { FilterType } from ".";

interface DataContainerProps {
    formId?: number;
    children?: ReactNode;
    showEmpty?: boolean;
}
const DataProvider: FC<DataContainerProps> = ({ formId, children, showEmpty = true }) => {
    const { formCode } = useParams<{ formCode?: string }>();
    const [form, setForm] = useState<FormItemProps | undefined | null>(undefined);
    const [fields, setFields] = useState<FieldItemProps[]>([]);
    const [filters, setFilters] = useState<FilterType[]>([]);
    const [q, setQ] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);

    const [options, setOptions] = useState<Record<string, DataItemProps[]>>({});
    const init = async (code?: string, formId?: number) => {
        if (formId) {
            const formRes = await apiFormFindById({ id: formId })
            if (formRes.status && formRes.data?.item) {
                setForm(formRes.data?.item);
            }
            else {
                setForm(null);
            }
        }
        else if (code) {
            const formRes = await apiFormFindByCode({ code })
            if (formRes.status && formRes.data?.item) {
                setForm(formRes.data?.item);
            }
            else {
                setForm(null);
            }
        }
    }

    useEffect(() => {
        if (form) {
            apiFieldIndex({ formId: form.id })
                .then(fieldRes => {
                    if (fieldRes.status && fieldRes.data.list) {
                        setFields(fieldRes.data.list);
                    }
                })
        }
        else {
            setFields([]);
        }
    }, [form])
    useEffect(() => {
        setLoading(false);
        setFields([]);
        setListData({
            data: [],
            options: []
        });
        if (formId || formCode) {
            init(formCode, formId);
        }
        else {
            setForm(null);
        }
    }, [formCode, formId])


    useEffect(() => {
        fields
            .filter(f => f.type === "reference" && f.referenceId)
            .map(field => {
                apiDataIdIndex({
                    formId: field.referenceId || 0,
                })
                    .then(res => {
                        if (res.status) {
                            setOptions(op => ({
                                ...op,
                                [`${field.referenceId}`]: res.data.list
                            }))
                        }
                    })
            })
    }, [fields])

    const [listData, setListData] = useState<{
        data: DataItemProps[];
        options: DataItemProps[];
        pagination?: PaginationProps;
    }>({
        data: [],
        options: []
    })

    const handleIndex = (data: IndexProps) => {
        setListData(l => {
            return {
                ...l,
                data: data.data,
                pagination: data.pagination
            }
        })
    }

    return <Fragment key={formCode}>
        <DataContext
            value={{
                form: form || undefined,
                setForm,
                fields,
                setFields,

                filters,
                setFilters,
                q,
                setQ,

                options,
                setOptions,

                loading,
                list: listData,
                handleLoading: (end) => setLoading(end ? false : true),
                handleIndex
            }}
        >
            <Fragment key={formCode}>
                {form === undefined && <AppLoading />}
                {form === null && showEmpty && "Không tìm thấy"}
                {form && form.code === formCode && <Outlet />}
                {children}
            </Fragment>
        </DataContext>
    </Fragment >
}

export default DataProvider;

interface IndexProps {
    data: DataItemProps[];
    pagination?: PaginationProps;
}
interface DataContextType {

    form?: FormItemProps;
    setForm: React.Dispatch<React.SetStateAction<FormItemProps | null | undefined>>;

    fields: FieldItemProps[];
    setFields: React.Dispatch<React.SetStateAction<FieldItemProps[]>>;

    filters: FilterType[];
    setFilters: React.Dispatch<React.SetStateAction<FilterType[]>>;
    q: string;
    setQ: React.Dispatch<React.SetStateAction<string>>;

    options: Record<string, DataItemProps[]>;
    setOptions: React.Dispatch<React.SetStateAction<Record<string, DataItemProps[]>>>;


    // Dữ liệu
    loading: boolean;
    list: {
        data: DataItemProps[];
        options: DataItemProps[];
        pagination?: PaginationProps;
    };
    handleLoading: (end?: boolean) => void;
    handleIndex: (data: IndexProps) => void;

}
const defaultValue: DataContextType = {
    setForm: () => { },
    fields: [],
    setFields: () => { },
    filters: [],
    setFilters: () => { },
    q: "",
    setQ: () => { },
    options: {},
    setOptions: () => { },

    loading: false,
    list: {
        data: [],
        options: []
    },
    handleLoading: () => { },
    handleIndex: () => { }
};
const DataContext = createContext<DataContextType>(defaultValue);
export const useFormData = () => {
    return useContext(DataContext);
};